import { Icon, Stack, Text, useTheme } from '@fluentui/react';
import React from 'react';
import { useStyles } from '../index.styles';
import { FlowApproval } from '../../__generated__/FlowApproval';
import ApprovedIcon from '../../../../../assets/svgs/ApproveStatusIcons/Approved.svg?react';
import { useCommonStyles } from 'common/styles';
import clsx from 'clsx';

export enum approvalFlowSidebarEnums {
  generalInfo = 'generalInfo',
  approvers = 'approvers',
  testing = 'testing',
}

export const Sidebar: React.FC<{
  approvalDetailsData: FlowApproval | undefined;
  onMenuSelect: (menuItem: approvalFlowSidebarEnums) => void;
  menuSelected: approvalFlowSidebarEnums;
}> = (props) => {
  const styles = useStyles();
  return (
    <Stack className={styles.sidebarContainer}>
      <MenuItem
        selected={props.menuSelected === approvalFlowSidebarEnums.generalInfo}
        iconName="AddNotes"
        title="General info"
        onPress={() => props.onMenuSelect(approvalFlowSidebarEnums.generalInfo)}
      />
      <MenuItem
        selected={props.menuSelected === approvalFlowSidebarEnums.approvers}
        iconName="UserFollowed"
        title="Approvers"
        onPress={() => props.onMenuSelect(approvalFlowSidebarEnums.approvers)}
      />
      <MenuItem
        selected={props.menuSelected === approvalFlowSidebarEnums.testing}
        iconName="Settings"
        title="Testing"
        isApproved={props.approvalDetailsData?.approval?._infoLines?.isTested}
        activeTestCount={
          props.approvalDetailsData?.approval?._infoLines?.activeTestCount
        }
        onPress={() => props.onMenuSelect(approvalFlowSidebarEnums.testing)}
      />
    </Stack>
  );
};

export const MenuItem: React.FC<{
  iconName: string;
  title: string;
  onPress: () => void;
  selected: boolean;
  isApproved?: boolean | null | undefined;
  activeTestCount?: number | null | undefined;
}> = (props) => {
  const styles = useStyles();
  const commonStyles = useCommonStyles();
  const theme = useTheme();
  return (
    <Stack
      onClick={props.onPress}
      tokens={{ childrenGap: 10 }}
      verticalAlign="center"
      className={styles.menuItem}
      style={{
        borderLeftWidth: 5,
        borderLeftColor: props.selected
          ? theme.palette.themeDark
          : 'transparent',
        borderLeftStyle: 'solid',
        backgroundColor: props.selected
          ? `${theme.palette.neutralQuaternaryAlt}8D`
          : undefined,
      }}
    >
      <Icon iconName={props.iconName} className={styles.menuItemIcon} />
      {!!props.activeTestCount ? (
        <Stack horizontal tokens={{ childrenGap: 5 }}>
          <Text
            variant="large"
            className={clsx(commonStyles.colorThemePrimary, commonStyles.bold)}
          >
            {`{${props.activeTestCount}}`}
          </Text>
          <Text
            variant="large"
            style={{
              textAlign: 'center',
            }}
          >
            {props.title}
          </Text>
          {props.isApproved && (
            <Stack
              style={{
                left: 130,
                marginBottom: 20,
                position: 'absolute',
                height: 25,
                width: 25,
              }}
            >
              <ApprovedIcon />
            </Stack>
          )}
        </Stack>
      ) : (
        <Stack>
          <Text
            variant="large"
            style={{
              textAlign: 'center',
            }}
          >
            {props.title}
          </Text>
        </Stack>
      )}
    </Stack>
  );
};
